/** Readable message from an axios error carrying a DRF response. */
export function apiErrorMessage(error, fallback = "Something went wrong. Please try again.") {
  const data = error?.response?.data;
  if (!data) return error?.message || fallback;
  if (typeof data === "string") return data.length < 300 ? data : fallback;
  if (data.error) return Array.isArray(data.error) ? data.error.join(", ") : String(data.error);
  if (data.detail) return String(data.detail);

  const parts = Object.entries(data).map(([field, value]) => {
    const text = Array.isArray(value) ? value.join(", ") : typeof value === "object" ? JSON.stringify(value) : value;
    return field === "non_field_errors" ? text : `${field}: ${text}`;
  });
  return parts.length ? parts.join(" | ") : fallback;
}
